export const SAVE_SOURCE = 'SAVE_SOURCE';
export const SAVE_DOCUMENT = 'SAVE_DOCUMENT';
export const SAVE_DOCUMENT_ID = 'SAVE_DOCUMENT_ID';
export const SAVE_COURSES = 'SAVE_COURSES';
export const SAVE_TESTS = 'SAVE_TESTS';
export const SAVE_EXPORT = 'SAVE_EXPORT';
